module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"es":{"tit":"Componentes","descrip":"Son los componentes de la solución constructiva"}}')
  delete Component.options._Ctor
}
